import type { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { TIMELINE_ITEM_IMPUTED_FIELD } from '@/common/api/types/planner/timelineItem';
import { OverflowTooltip } from '@/common/components/ui/OverflowTooltip';
import { ImputedBadge } from '@/features/items/components/data-table/cells/ImputedBadge';
import type { ItemsTableRow } from '../types';

export const TeamDisplayCell = ({ value, row }: GridRenderCellParams<ItemsTableRow>) => {
  const isImputed = row.imputedFields?.includes(TIMELINE_ITEM_IMPUTED_FIELD.TEAM) ?? false;

  if (!value) {
    return null;
  }

  if (!isImputed) {
    return <OverflowTooltip>{value}</OverflowTooltip>;
  }

  return (
    <div className="flex items-center gap-2 min-w-0">
      <ImputedBadge />
      <OverflowTooltip>{value}</OverflowTooltip>
    </div>
  );
};
